import React, { useEffect, useState } from 'react';
import 'leaflet/dist/leaflet.css';
import './PopupINV.css';
import { useTranslation } from 'react-i18next';

const PopupINV = (props) => {

    const { t } = useTranslation();
    const { nombre, idCT, idINV, estado, color, potNominal, potActiva, energyDay, strings, produciendo, potPico, pr } = props;

    //Deshabilitar el link si no hay pantalla de inversor
    const screen = JSON.parse(sessionStorage.getItem('ScreenConfiguration')).filter(screen => screen.Screen === "Inverter");
    const [hrefDisabled, setHrefDisabled] = useState(<></>);
    var link = "/#/inv/" + idCT + "/" + idINV;
    useEffect(() => {
        if (screen[0].Enabled === false) {
            setHrefDisabled(<a className='a-ver-inv' style={{ cursor: 'none' }}>{nombre}</a>)
        } else {
            setHrefDisabled(<a className='a-ver-inv' href={link}>{nombre}</a>)
        }
    }, []);


    var colorAux;
    color === '#ffffff' ? colorAux = '#000000' : colorAux = color;

    return (
        <div className='container-fluid' style={{ width: 'max-content', padding: '0px' }}>
            <div className='row justify-content-center'>
                <div className='col-auto'>
                    {hrefDisabled}
                </div>
            </div>
            <div className='row' style={{ margin: '5px' }}>
                <div className='col'>{t('scada.map.popupINV.status')} <strong style={{ color: colorAux }}>{estado}</strong></div>
            </div>
            <div className='row' style={{ margin: '5px' }}>
                <div className='col-auto'>{t('scada.map.popupINV.nominalPower')} <strong>{potNominal}</strong></div>
                <div className='col-auto'>{t('scada.map.popupINV.peakPower')} <strong>{potPico}</strong></div>
            </div>
            <div className='row' style={{ margin: '5px' }}>
                <div className='col-auto'>{t('scada.map.popupINV.activePower')} <strong>{potActiva}</strong></div>
            </div>
            <div className='row' style={{ margin: '5px' }}>
                <div className='col-auto'>{t('scada.map.popupINV.dailyEnergy')} <strong>{energyDay}</strong></div>
                <div className='col-auto'>{t('scada.map.popupINV.pr')} <strong>{pr}</strong></div>
            </div>
        </div>
    );
};

export default PopupINV;